'use strict';

window.TES = window.TES || {};

$(function () {

    var $reviewContainer = $('#add-review-container');
    var resourceAuthor = window.TES.resource && window.TES.resource.authorId.toString();

    var user = window.TES.user;

    var addReviewController = new AddReviewController($reviewContainer);

    function showAddReviewLinkIfApplicable() {
        if (!currentUserIsAuthor()) {
            $('#add-review-cta-container').show();
        }
    }

    function currentUserIsAuthor() {
        return user.isAuthenticated() && user.getId() === resourceAuthor;
    }

    function allowAddingReviewIfAuthenticated() {
        if (user.isAuthenticated()) {
            addReviewController.enable();
        }
    }

    function addPagination() {
        $('#ContentPlaceHolder2_lnkMoreReviews').on('click', function(event) {
            $('table.reviews').addClass('paginate');
            $('#ContentPlaceHolder2_lnkMoreReviews').hide();
            return false;
        });
    }

    addPagination();
    allowAddingReviewIfAuthenticated();
    showAddReviewLinkIfApplicable();
});

function AddReviewController(reviewContainer) {

    this._$reviewContainer = reviewContainer;
    this._dialog = new Dialog(reviewContainer, this.add.bind(this), this.cancel.bind(this));

    this._$rating = $('#ContentPlaceHolder2_rating');
    this._$comment = $('#ContentPlaceHolder2_review');
    this._$errorMessage = $('#ContentPlaceHolder2_pErrorMessage');
    this._$successMessage = $('#ContentPlaceHolder2_pMessage');
}

AddReviewController.prototype = {

    enable: function() {
        $('#ContentPlaceHolder2_lnkAddReview').on('click', this._dialog.show.bind(this._dialog));
        $('#ContentPlaceHolder2_lnkAddReview').attr('href', '#');
    },

    cancel: function (event) {
        this._$errorMessage.hide();
        return false;
    },

    add: function (event) {
        this._$successMessage.hide();
        this._$errorMessage.hide();
        if (this._isRatingValid()) {
            $.ajax({
                type: 'POST',
                dataType: 'html',
                contentType: 'application/json; charset=utf-8',
                url: '/api/review',
                data: JSON.stringify(this._gatherReviewMetadata()),
                success: this._addSuccess.bind(this),
                error: this._addError.bind(this)
            });
        } else {
            this._$errorMessage.show();
        }
        return false;
    },

    _isRatingValid: function() {
        return this._$rating && this._$rating.val() !== '0';
    },

    _addSuccess: function (fragment) {

        var $reviews = $('#ContentPlaceHolder2_divReviews');
        var $reviewsLength = $('#reviewsLength .data');

        $reviews.replaceWith(fragment);
        $reviewsLength.html($(fragment).find('tbody tr').length);

        this._$successMessage.show();

        this._dialog.hide();
        this._$rating.val(0);
        this._$comment.val('');
    },

    _addError: function () {
        this._$errorMessage.show();
    },

    _gatherReviewMetadata: function() {
        return {
            rating: this._$rating.val(),
            comment: this._$comment.val(),
            asset: this._gatherResourceMetadata()
        };
    },

    _gatherResourceMetadata: function() {
        return {
            id: $('#resourceId').val(),
            type: 'resources',
            authorId: this._$reviewContainer.attr('data-author-id')
        };
    },

    _$reviewContainer: null,
    _dialog: null,
    _$rating: null,
    _$comment: null,
    _$errorMessage: null

};

function Dialog(reviewContainer, onAdd, onCancel) {
    this._$reviewContainer = reviewContainer;
    this._onAdd = onAdd;
    this._onCancel = onCancel;

    $('#cancelButton').on('click', this.cancel.bind(this));
    $('#ContentPlaceHolder2_SaveButton').on('click', this._onAdd);
}

Dialog.prototype = {

    show: function () {

        $('#ContentPlaceHolder2_pMessage').hide();
        this._$reviewContainer.find('.boxed').hide();
        $('#addReview').show();

        return false;
    },

    cancel: function () {
        this.hide();
        this._onCancel();
        return false;
    },

    hide: function () {
        this._$reviewContainer.find('.boxed').show();
        $('#addReview').hide();
    }

};
